import { render, staticRenderFns } from "./PosPT.vue?vue&type=template&id=17c26010&scoped=true"
import script from "./PosPT.vue?vue&type=script&lang=js"
export * from "./PosPT.vue?vue&type=script&lang=js"
import style0 from "./_layout.css?vue&type=style&index=0&id=17c26010&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c26010",
  null
  
)

export default component.exports